/* eslint-disable consistent-return */
import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Wrapper = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    margin: `${defaultTheme.spacing.xs} 2px 0 0`,
  }),
);

export const ShortendRaceEventName = styled.span(() =>
  mq({
    fontSize: '10px',
    background: defaultTheme.background.darkGray,
    borderRadius: '2px',
    color: defaultTheme.color.white,
    marginRight: '2px',
    padding: '2px',
  }),
);

export const Rank = styled.span(() =>
  mq({
    fontSize: defaultTheme.font.size.xs,
    marginRight: defaultTheme.spacing.xs,
    textDecorationLine: 'underline',
  }),
);

export const StyledLink = styled.a(() =>
  mq({
    cursor: 'pointer',
    ...hoverOpacity,
  }),
);
